module.exports = __webpack_public_path__ + "img/loginLogo.a1d056b9.png";